import useFetchNotifications from "../../../api/api-hooks/notifications/useFetchNotifications";
import SkeletonLoader from "../../../elements/SkeletonLoader";
import { RefObject } from "react";
import { WhisperInstance } from "rsuite";
import { useNavigate } from "react-router-dom";
import { useAtomValue } from "jotai";
import { tenantIDAtom } from "../../../atoms/GlobalAtoms";
import {
  InitialNotificationQuery,
  NotificationsList,
} from "../../../views/cloud/Notifications/NotificationsPage";

interface Props {
  open: boolean;
  whisperRef: RefObject<WhisperInstance>;
}

const NotificationQuery = InitialNotificationQuery();

export default function NotificationsMenu({ open, whisperRef }: Props) {
  const navigate = useNavigate();
  const tenantID = useAtomValue(tenantIDAtom);
  const { notifications, loading } = useFetchNotifications(
    NotificationQuery,
    !open
  );

  return (
    <>
      <div className="d-flex align-items-center justify-content-between px-2 pt-1 pb-2">
        <h3 className="mb-0">Notifications</h3>
        {!loading && (
          <div
            className="text-primary font-weight-500 cursor-pointer"
            onClick={() => {
              whisperRef.current?.close();
              return navigate(`/clouds/${tenantID}/user/notifications`);

              // TODO: Add to notifications page
              // const unreadNotifications = notifications?.filter(
              //   (n: any) => !n?.Read
              // );

              // if (!unreadNotifications?.length) return;

              // readNotifications({
              //   notificationIds:
              //     unreadNotifications?.map((n: any) => n._id) || [],
              // });
            }}
          >
            View All
          </div>
        )}
      </div>
      <div style={{ overflowY: "auto", maxHeight: 400 }}>
        {loading && (
          <div className="px-2">
            <SkeletonLoader height={50} />
            <SkeletonLoader height={50} />
            <SkeletonLoader height={50} />
          </div>
        )}
        {!loading && !notifications.length && (
          <div className="p-2 text-center bg-ultralight rounded m-2">
            <h5>No notifications yet</h5>
            <div>We will let you know when something arrives!</div>
          </div>
        )}
        {!loading && notifications?.length > 0 && (
          <div className="px-1 mt--2 mb--2">
            <NotificationsList
              notifications={notifications}
              loading={false}
              onSelectNotification={() => whisperRef.current?.close()}
              small
            />
          </div>
        )}
      </div>
    </>
  );
}
